import { Card, CardContent, Typography } from '@eye-able/ui';
import { useInlineTranslation } from '@/i18n/hooks/useInlineTranslation';

function NoIssuesPlaceholder() {
  const { t } = useInlineTranslation();
  return (
    <Card>
      <CardContent className='eye:p-s'>
        <Typography className='eye:text-grey-120'>{t('noIssues')}</Typography>
      </CardContent>
    </Card>
  );
}

export { NoIssuesPlaceholder };
